import create from 'zustand';
import StorageService from '../services/StorageService';

// SET GLOBAL VARIABLES
const loggedInUserInStorage = StorageService.getCurrentUser();

const useAppStore = create(() => ({
  currentUser: loggedInUserInStorage,
  companySettings: null,
}));

export const setCurrentUser = async (userObject) => {
  useAppStore.setState({ currentUser: userObject, companySettings: userObject?.principal?.companySettings });
  StorageService.setCurrentUser(userObject);
  StorageService.setCompanySettings(userObject?.principal?.companySettings);
};

export const getCurrentUser = () => {
  return useAppStore.getState().currentUser;
};

export const getCompanySettings = () => {
  return useAppStore.getState().companySettings;
};

export const resetStore = () => {
  useAppStore.setState({
    currentUser: null,
    companySettings: null,
  });
  StorageService.removeUser();
  StorageService.removeCompanySettings();
  StorageService.removeDefaultEmployeeId();
  StorageService.removeAgendaEmployeeSelection();
  StorageService.resetAuthVersion();
};

export const updateTokens = (tokenAndRefreshToken) => {
  const loggedInUser = StorageService.getCurrentUser();

  if (loggedInUser) {
    const newCurrentUser = {
      ...loggedInUser,
      ...tokenAndRefreshToken,
    };
    StorageService.setCurrentUser(newCurrentUser);
    useAppStore.setState({ currentUser: newCurrentUser });
  }
};

export const currentUserSelector = (state) => state.currentUser;
export const companySettingsSelector = (state) => state.companySettings;
export { useAppStore };
